import { WidgetSize, WidgetType } from 'components/farm-dashboard/types'
import { LicensesType } from 'models/IUserData'

export const FEED_TABLE_WIDGETS = [
	{
		id: WidgetType.FEED_CONSUMPTION,
		type: WidgetType.FEED_CONSUMPTION,
		size: WidgetSize.MEDIUM,
		license: LicensesType.FOOD_TABLE,
	},
	{
		id: WidgetType.FEED_CONSUMPTION_SMALL,
		type: WidgetType.FEED_CONSUMPTION_SMALL,
		size: WidgetSize.SMALL,
		license: LicensesType.FOOD_TABLE,
	},
	{
		id: WidgetType.REMAINING_FEED_SMALL,
		type: WidgetType.REMAINING_FEED_SMALL,
		size: WidgetSize.SMALL,
		license: LicensesType.FOOD_TABLE,
	},
	{
		id: WidgetType.REMAINING_FEED_PROCENT,
		type: WidgetType.REMAINING_FEED_PROCENT,
		size: WidgetSize.SMALL,
		license: LicensesType.FOOD_TABLE,
	},

	{
		id: WidgetType.FEED_CONSUMPTION_LINE_CHART,
		type: WidgetType.FEED_CONSUMPTION_LINE_CHART,
		size: WidgetSize.LARGE,
		license: LicensesType.FOOD_TABLE,
	},
	{
		id: WidgetType.FEED_CONSUMPTION_BAR_CHART,
		type: WidgetType.FEED_CONSUMPTION_BAR_CHART,
		size: WidgetSize.FULL,
		license: LicensesType.FOOD_TABLE,
	},
	{
		id: WidgetType.PSV_DYNAMIC_CHART,
		type: WidgetType.PSV_DYNAMIC_CHART,
		size: WidgetSize.LARGE,
		license: LicensesType.FOOD_TABLE,
	},

	{
		id: WidgetType.PSV_AVG_MILKY,
		type: WidgetType.PSV_AVG_MILKY,
		size: WidgetSize.SMALL,
		license: LicensesType.FOOD_TABLE,
	},

	{
		id: WidgetType.PSV_AVG_DRY,
		type: WidgetType.PSV_AVG_DRY,
		size: WidgetSize.SMALL,
		license: LicensesType.FOOD_TABLE,
	},
	{
		id: WidgetType.PSV_WIDGET,
		type: WidgetType.PSV_WIDGET,
		size: WidgetSize.SMALL,
		license: LicensesType.FOOD_TABLE,
	},

	{
		id: WidgetType.PSV_HERD_STRUCTURE,
		type: WidgetType.PSV_HERD_STRUCTURE,
		size: WidgetSize.MEDIUM,
		license: LicensesType.FOOD_TABLE,
	},
	{
		id: WidgetType.FEED_AVAILABILITY_AVG,
		type: WidgetType.FEED_AVAILABILITY_AVG,
		size: WidgetSize.SMALL,
		license: LicensesType.FOOD_TABLE,
	},

	{
		id: WidgetType.FEED_PLAN_COMPLIANCE,
		type: WidgetType.FEED_PLAN_COMPLIANCE,
		size: WidgetSize.SMALL,
		license: LicensesType.FOOD_TABLE,
	},

	{
		id: WidgetType.DEVIATIONS_FEED_TABLE,
		type: WidgetType.DEVIATIONS_FEED_TABLE,
		size: WidgetSize.SMALL,
		license: LicensesType.FOOD_TABLE,
	},
	{
		id: WidgetType.FEED_AVAILABILITY,
		type: WidgetType.FEED_AVAILABILITY,
		size: WidgetSize.FULL,
		license: LicensesType.FOOD_TABLE,
	},
]
